import { Typography } from "@mui/material";
import { TALENT_WIDTH_FULL } from "@/features/talent/constants/width";
import { Box } from "@mui/system";

export const TalentTitle = () => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 3, width: `${TALENT_WIDTH_FULL}px` }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ flex: 1 }}>
        <Typography variant="head20Bold">新規人材登録</Typography>
      </Box>
    </Box>
  );
};
